import _ from 'lodash';

import { BASE_URL } from '../config';
import AuthService from '../utils/AuthService';

const token = () => AuthService.getAccessToken();

const _processResponse = function (response) {
  const status = Number(response.status);
  // console.log('status', status);

  const contentType = response.headers.get('content-type');

  switch (status) {
    case 200:
    case 201:
      if (contentType.indexOf('json') >= 0) {
        return response.json();
      } else if (contentType.indexOf('pdf') >= 0 || contentType.indexOf('image') >= 0) {
        return response.blob();
      }

      return response.text();
    case 204:
      return {};
    case 401:
    case 403:
      window.location = '/logout';
      throw response;//new Error('Unauthorized');
    default:
      throw response;
  }
};

const _processError = function (err) {
  // console.log('_processError', err);
  // console.log('err.json', err.json);
  // console.log('status', err.status);

  if (err.status === 404) {
    const err = new Error('Resource not found');
    err.statusCode = 404;
    throw err;
  }

  if (err.json) {
    return err.json().then((resp) => {
      console.error('resp', resp);
      throw new Error((resp.error && resp.error.message) || (resp.error && resp.error.description) || resp.message || resp.description || 'Unable to process this request at this time');
      // }).catch(err => {
      //   console.error('processError', err);
      //   throw new Error('Unrecognized server response. Please try again later')
    });
  }

  throw new Error('Unrecognized server response. Please try again later');
};

const formatParams = (params) => {
  let query = _.join(_.filter(_.keys(params || {}), (key) => key !== 'sorting').map((key) => `${key}=${encodeURIComponent(params[key])}`), '&');
  if (params && params.sorting) {
    query += '&' + _.join(params.sorting.filter(sort => sort.ascending !== undefined).map(sort => 'sorting=' + (sort.ascending ? '' : '-') + sort.column), '&');
  }
  return query;
}

const getPath = (options) => {
  return BASE_URL;
}

const get = (options) => {
  const params = formatParams(options.params);

  const hdrs = _.extend({
    Authorization: `bearer ${token()}`,
    Accept: 'application/json',
  }, options.headers);

  let url = `${getPath(options)}${options.url}`;
  if (params) {
    url = `${url}${url.indexOf('?') >= 0 ? '&' : '?'}${params}`;
  }
  return window.fetch(url, {
    method: 'get',
    headers: hdrs,
  }).then(_processResponse)
    .catch(_processError);
};

const getDataUri = (options) => new Promise((resolve) => {
  const xhr = new XMLHttpRequest();
  xhr.responseType = 'blob';
  xhr.onload = function () {
    const reader = new FileReader();
    reader.onloadend = function () {
      resolve(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', getPath(options) + options.url);
  xhr.setRequestHeader('Authorization', `bearer ${token()}`);
  xhr.send();
});

const post = (options) => {
  const hdrs = _.assign({
    Authorization: `bearer ${token()}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }, options.headers);

  // console.log('options.params',options.params);
  const params = formatParams(options.params);

  return window.fetch(`${getPath(options)}${options.url}?${params}`, {
    method: 'post',
    headers: hdrs,
    body: _.isString(options.data) ? options.data : JSON.stringify(options.data),
  }).then(_processResponse)
    .catch(_processError);
};

const postNoAuth = (options) => {
  const hdrs = _.assign({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }, options.headers);

  // console.log('options.params',options.params);
  const params = formatParams(options.params);

  return window.fetch(`${getPath(options)}${options.url}?${params}`, {
    method: 'post',
    headers: hdrs,
    body: _.isString(options.data) ? options.data : JSON.stringify(options.data),
  }).then(_processResponse)
    .catch(_processError);
};

const postBinary = (options) => {
  console.log('options.options', options.data.type, options.data.size);
  const hdrs = _.assign({
    Authorization: `bearer ${token()}`,
    Accept: 'application/json',
  }, options.headers);

  // console.log('options.params',options.params);
  const params = formatParams(options.params);

  return window.fetch(`${getPath(options)}${options.url}?${params}`, {
    method: 'post',
    headers: hdrs,
    body: options.data,
  }).then(_processResponse)
    .catch(_processError);
};

const postCsv = (options) => {
  console.log('postCsv', options);
  const hdrs = _.assign({
    Authorization: `bearer ${token()}`,
    'Content-Type': 'text/csv',
    Accept: 'application/json',
  }, options.headers);

  // console.log('options.params',options.params);
  const params = formatParams(options.params);

  return window.fetch(`${getPath(options)}${options.url}${options.url.indexOf('?') >= 0 ? '&' : '?' }${params}`, {
    method: 'post',
    headers: hdrs,
    body: options.data,
  }).then(_processResponse)
    .catch(_processError);
};

const put = (options) => {
  const hdrs = _.assign({
    Authorization: `bearer ${token()}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }, options.headers);

  const params = formatParams(options.params);

  return window.fetch(`${getPath(options)}${options.url}?${params}`, {
    method: 'put',
    headers: hdrs,
    body: _.isString(options.data) ? options.data : JSON.stringify(options.data),
  }).then(_processResponse)
    .catch(_processError);
};

const remove = (options) => {
  const headers = {
    Authorization: `bearer ${token()}`,
  };

  return window.fetch(`${getPath(options)}${options.url}`, {
    method: 'delete',
    headers,
  }).then(_processResponse)
    .catch(_processError);
};

export {
  get,
  getDataUri,
  post,
  postNoAuth,
  postCsv,
  postBinary,
  put,
  remove,
  BASE_URL,
};



// WEBPACK FOOTER //
// ./src/utils/request.js